var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8,
    y: -8,
    width: 48,
    height: 48
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4px)",
      clipPath: "url(#bgblur_0_2850_23566_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59961 0.400391H22.4004C27.4811 0.400602 31.5994 4.5189 31.5996 9.59961V22.4004C31.5994 27.4811 27.4811 31.5994 22.4004 31.5996H9.59961C4.5189 31.5994 0.400602 27.4811 0.400391 22.4004V9.59961C0.400602 4.5189 4.5189 0.400602 9.59961 0.400391Z",
    fill: "#4092FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59961 0.400391H22.4004C27.4811 0.400602 31.5994 4.5189 31.5996 9.59961V22.4004C31.5994 27.4811 27.4811 31.5994 22.4004 31.5996H9.59961C4.5189 31.5994 0.400602 27.4811 0.400391 22.4004V9.59961C0.400602 4.5189 4.5189 0.400602 9.59961 0.400391Z",
    stroke: "#4092FF",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.054 8H23.74L17.8733 14.7911L24.8002 24H19.3576L15.1167 18.4178L10.2396 24H7.55361L13.8444 16.7467L7.2002 8H12.7841L16.6363 13.12L21.054 8ZM20.0998 22.3644H21.5841L11.9713 9.52889H10.3456L20.0998 22.3644Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2850_23566_clip_path",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.59961 0.400391H22.4004C27.4811 0.400602 31.5994 4.5189 31.5996 9.59961V22.4004C31.5994 27.4811 27.4811 31.5994 22.4004 31.5996H9.59961C4.5189 31.5994 0.400602 27.4811 0.400391 22.4004V9.59961C0.400602 4.5189 4.5189 0.400602 9.59961 0.400391Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterX);
export default __webpack_public_path__ + "static/media/footerX.eb3bd27c308e6a45e1960b1a34ec89fe.svg";
export { ForwardRef as ReactComponent };